<template>
  <div>
    <AddUser
      v-if="addUserModal"
      :show="addUserModal"
      v-on:closeAddUserModal="$emit('closeAddUserModal')"
      @showSuccessPopup="showSuccessPopup = true"
    />
    <EditUser
      v-if="editUserModal"
      :show="editUserModal"
      :user="editedUser"
      v-on:closeEditUserModal="editUserModal = false"
      @showSuccessPopup="showSuccessPopup = true"
    />
    <DeleteModal
      :show="showDelete"
      @close="closeDelete"
      :name="$t('user')"
      @submit="doDelete"
    />
    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="$t('success_msg_user')"
      :heading="$t('success_heading_user')"
    />
    <div>
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>
      <!-- <div class="page-breadcrumb">
        <div class="row">
          <div class="col-md-5 align-self-center mb-2">
            <h6 class="page-title">{{ $t("all_users") }}</h6>
          </div>
          <div class="col-md-7 align-self-center">
            <div class="d-flex align-items-center justify-content-end">
              <a
                class="btn btn-secondary mr-2"
                @click.prevent="exportRecord"
                href="javascript:void(0)"
              >
                {{ $t("exp-csv") }}
              </a>
              <button
                data-step="1"
                data-intro="<h5 style='margin-bottom: 1rem; color: #213e7a'>Users</h5>Assign members of your team to monitor selected devices."
                @click="addUserModal = true"
                class="btn btn-primary"
              >
                {{ $t("add_user") }}
              </button>
            </div>
          </div>
        </div>
      </div> -->
      <div class="container-fluid">
        <div class="card" style="max-height: 40rem; overflow-y: auto">
          <div class="card-body">
            <div class="col-sm-12 col-md-12">
              <TableSearch @handleSearch="handleSearch" />
            </div>
            <div class="row">
              <div class="col-md-12">
                <div ref="content" class="table-responsive">
                  <table id="order-listing" class="table table-hover display">
                    <thead style="background-color:rgba(240, 244, 251, 0.60)">
                      <tr>
                        <th
                          :key="index"
                          v-for="(column, index) in tableColumns"
                          @click="sortBy(column[1])"
                          style="cursor: pointer; text-align: left"
                        >
                          {{ column[0] }}
                          <span
                            class="arrow"
                            :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                          ></span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        :key="index"
                        v-for="(user, index) in paginatedData"
                        class="user-row"
                        style="border-bottom: unset;"
                        :class="{
                          'gray-bg': index % 2 !== 0,
                        }"
                      >
                        <!-- <td>{{ users.indexOf(user) + 1 }}</td> -->
                        <td>{{ user.fullname }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.role }}</td>
                        <td>
                          <!-- <div style="cursor:pointer" class="btn-group">
                            <div
                              @click.prevent="showRemoveUser(user.id)"
                              class="fas fa-ellipsis-h"
                            ></div>
                            <div
                              class="dropdown-menu removeuser-dropdown"
                              v-bind:class="{
                                show: RemoveUserShow(user.id),
                              }"
                              x-placement="bottom-start"
                            >
                              <a
                                href="javascript:void(0)"
                                class="dropdown-item mb-2"
                                @click="edituser(user.id)"
                                style="border: 1px solid rgba(0, 0, 0, 0.4); border-radius: 5px"
                              >
                                {{ $t("edit_user") }}
                              </a>
                            </div>
                          </div> -->

                          <div class="d-flex align-items-center col-gap-1">
                            <span
                              class="cursor-pointer"
                              @click="edituser(user.id)"
                            >
                              <IconEdit />
                            </span>
                            <span
                              class="cursor-pointer"
                              @click="openDelete(user.id)"
                            >
                              <IconDelete />
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <Pagination
                  :pageCount="pageCount"
                  :data="paginatedData"
                  :sizeperpage="sizeperpage"
                  :pageNumber="pageNumber"
                  :pages="pages"
                  @goToLastPage="goToLastPage"
                  @nextPage="nextPage"
                  @handlePageChange="handlePageChange"
                  @goToFirstPage="goToFirstPage"
                  @prevPage="prevPage"
                  @onchange="onchange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import store from "../../store/index";
import introJs from "intro.js";
import "intro.js/introjs.css";

import AddUser from "../Modals/AddUser";
import EditUser from "../Modals/EditUser";
import IconEdit from "../../components/Iconsvg/IconEditUser.vue";
import IconDelete from "../../components/Iconsvg/IconDeleteUser.vue";
import tableMixin from "../../mixins/tableMixinWithBackend";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
import DeleteModal from "../Modals/DeleteModal.vue";

export default {
  name: "Users",
  props: {
    addUserModal: Boolean,
    handleCloseAdd: Function
  },
  components: {
    Loading,
    EditUser,
    AddUser,
    IconEdit,
    IconDelete,
    Pagination,
    TableSearch,
    SuccessModal,
    DeleteModal,
  },
  mixins: [tableMixin],
  data() {
    return {
      isLoading: true,
      fullPage: true,
      Tag: "",
      editedUser: [],
      // addUserModal: false,
      editUserModal: false,
      showSuccessPopup: false,
      showDelete: false,
      dataTable: [],
    };
  },
  mounted() {
    this.getUsers(this.params).then(() => {
      this.isLoading = false;
    });
    
  },
  beforeRouteEnter(to, from, next) {
    // Checks if the user is a staff
    if (store.getters.profile.role === "staff") {
      next(from);
    } else {
      next();
    }
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },

  computed: {
    ...mapGetters(["users", "profile", "usersMeta"]),
    paginationMeta() {
      return this.usersMeta;
    },
    tableColumns() {
      return [
        [this.$t("name"), "fullname"],
        [this.$t("email"), "email"],
        [this.$t("user_rights"), "role"],
        [this.$t("action"), "column2"],
      ];
    },
  },
  methods: {
    ...mapActions(["getUsers", "addUser", "editUser", "deleteUser"]),
    closeDelete() {
      this.id = "";
      this.showDelete = false;
    },
    doDelete() {
      this.isLoading = true;
      this.deleteUser(this.id).then(() => {
        this.getUsers();
        this.isLoading = false;
        this.showDelete = false;
      });
    },
    showRemoveUser(id) {
      if (this.RemoveUserShow(id)) {
        this.Tag = "";
      } else {
        this.Tag = id;
      }
    },
    RemoveUserShow(id) {
      if (id == this.Tag) {
        return true;
      } else {
        return false;
      }
    },
    edituser(id) {
      this.editedUser = this.users.filter((user) => user.id == id);
      this.Tag = "";

      this.editUserModal = true;
    },
    openDelete(id) {
      this.showDelete = true;
      this.id = id;
    },
    handleUserChange(params) {
      this.isLoading = true;
      this.getUsers(params)
        .then(() => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    doSearch() {
      let params = {
        ...this.params,
        keyword: this.searchQuery,
      };
      this.handleUserChange(params);
    },
  },
  watch: {
    users: {
      handler: function() {
        this.dataTable = this.users;
      },
      deep: true,
    },
    params() {
      this.handleUserChange(this.params);
    },
  },
};
</script>

<style scoped>
.introjs {
  position: fixed;
  top: 0.3rem;
  right: 12rem;
  z-index: 60;
}
@media (max-width: 991px) {
  .introjs {
    display: none !important;
  }
}
td {
  /* border-bottom: 1px rgba(0, 0, 0, 0.1) solid; */
}
th.active {
  color: #fff;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.device-dropdown {
  position: absolute;
  will-change: transform;
  top: 0px;
  left: -50%;
  transform: translate3d(313px, 35px, 0px);
  max-height: 200px;
  width: 15rem;
  overflow-y: auto;
}
.removeuser-dropdown {
  left: -1000%;
}
.dropdown-button {
  border-radius: 2px;
}
.gray-bg {
  background-color: rgba(240, 244, 251, 0.6);
}
tr th {
  border-bottom: unset !important;
}
</style>

<i18n>
{
	"en": {
		"add_user": "Add a User",
		"action": "Action",
		"all_users": "All Users",
		"edit_user": "Edit User",
		"email": "Email",
		"man_user_right": "Manage user rights for members of your business",
		"name": "Name",
		"user_rights": "User Right"
	},
	"es": {
		"add_user": "Agregar un usuario",
		"all_users": "Todos los usuarios",
		"edit_user": "editar usuario",
		"email": "Email",
		"man_user_right": "Administre los derechos de usuario de los miembros de su empresa",
		"name": "Nombre",
		"user_rights": "Derechos de usuario"
	},
	"fr": {
		"add_user": "Ajouter un utilisateur",
		"all_users": "Tous les utilisateurs",
		"edit_user": "Modifier l'utilisateur",
		"email": "E-mail",
		"man_user_right": "Gérez les droits d'utilisation des membres de votre entreprise",
		"name": "Nom",
		"user_rights": "Droits de l'utilisateur"
	},
	"sw": {
		"add_user": "ONGEZA MTUMIAJI",
		"all_users": "Watumiaji Wote",
		"edit_user": "Badilisha mtumiaji",
		"email": "Barua pepe",
		"man_user_right": "Dhibiti haki za mtumiaji za wanachama wa biashara yako",
		"name": "Jina",
		"user_rights": "Haki za Mtumiaji"
	}
}
</i18n>
